module.exports = __webpack_public_path__ + "img/3.909fde9a.png";